import { motion } from 'framer-motion';
import { useState } from 'react';

const FIXED_SMS_TEMPLATE = '안녕하세요! 제주블리 여행사에 문의 드립니다.\n이름 : \n지역 : \n연락처 : \n내용 : ';

export function BookingSection() {
  const [showSmsModal, setShowSmsModal] = useState(false);
  const [smsMessage, setSmsMessage] = useState(FIXED_SMS_TEMPLATE);
  const [isSending, setIsSending] = useState(false);

  const handleSendSms = () => {
    if (!smsMessage.trim()) {
      alert('메시지를 입력해주세요.');
      return;
    }

    setIsSending(true);
    
    const phoneNumber = '01056857818';
    const encodedMessage = encodeURIComponent(smsMessage);
    
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    let smsLink = '';
    if (isIOS) {
      smsLink = `sms:${phoneNumber}&body=${encodedMessage}`;
    } else if (isAndroid) {
      smsLink = `sms:${phoneNumber}?body=${encodedMessage}`;
    } else {
      smsLink = `sms:${phoneNumber}?body=${encodedMessage}`;
    }
    
    try {
      window.location.href = smsLink;
    } catch (error) {
      const link = document.createElement('a');
      link.href = smsLink;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    
    setTimeout(() => {
      setIsSending(false);
      alert('📱 문자 앱이 열렸습니다!\n\n메시지를 확인하시고 전송 버튼을 눌러주세요.\n\n※ 문자 앱이 열리지 않았다면:\n1. 브라우저 설정에서 팝업 허용\n2. 직접 010-5685-7818로 문자 전송');
      setShowSmsModal(false);
      setSmsMessage(FIXED_SMS_TEMPLATE);
    }, 1000);
  };

  const handleOpenModal = () => {
    setSmsMessage(FIXED_SMS_TEMPLATE);
    setShowSmsModal(true);
  };

  return (
    <>
      <section id="booking" className="py-20 sm:py-24 md:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16 sm:mb-20"
          >
            <div className="inline-flex items-center gap-3 bg-[#0E7FC0]/10 px-6 py-3 rounded-full mb-6 sm:mb-8">
              <i className="ri-calendar-check-line text-[#0E7FC0] text-lg sm:text-xl"></i>
              <span className="text-[#0E7FC0] text-base sm:text-lg font-medium">
                예약 상담
              </span>
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#2C2C2C] mb-6 sm:mb-8 leading-tight px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              지금 바로<br />
              상담받으세요
            </h2>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              로컬 전문가가 당신만의<br />
              특별한 제주 여행을 설계해드립니다
            </p>
          </motion.div>

          {/* 예약 상담 카드 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white rounded-3xl shadow-2xl p-8 sm:p-12 max-w-5xl mx-auto"
          >
            <div className="text-center mb-12">
              <h3 className="text-3xl sm:text-4xl font-bold text-[#2C2C2C] mb-4">
                3가지 방법으로 간편하게
              </h3>
              <p className="text-gray-600 text-lg sm:text-xl">
                상담시간: 08:00-22:00 | 연중무휴
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
              {/* 전화 상담 */}
              <a
                href="tel:010-5685-7818"
                className="group bg-gradient-to-br from-[#0E7FC0] to-[#0a5f92] rounded-2xl sm:rounded-3xl p-8 sm:p-10 text-white hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <i className="ri-phone-line text-3xl sm:text-4xl"></i>
                </div>
                <h4 className="text-2xl font-bold mb-3 text-center">전화 상담</h4>
                <p className="text-white/90 text-center text-base mb-4">즉시 연결</p>
                <p className="text-center font-bold text-xl sm:text-2xl">010-5685-7818</p>
              </a>

              {/* 카카오톡 상담 */}
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('openKakaoModal'))}
                className="group bg-gradient-to-br from-[#FEE500] to-[#fdd800] rounded-2xl sm:rounded-3xl p-8 sm:p-10 text-[#3C1E1E] hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer relative overflow-hidden w-full text-left"
              >
                <div className="absolute top-3 right-3 bg-[#3C1E1E]/10 text-[#3C1E1E] text-xs font-bold px-3 py-1 rounded-full">
                  ID 안내
                </div>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#3C1E1E]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <i className="ri-kakao-talk-fill text-3xl sm:text-4xl"></i>
                </div>
                <h4 className="text-2xl font-bold mb-3 text-center">카카오톡</h4>
                <p className="text-[#3C1E1E]/80 text-center text-base mb-4">1:1 채팅 상담</p>
                <p className="text-center font-bold text-xl sm:text-2xl">ID : gwonbj88</p>
              </button>

              {/* 문자 상담 */}
              <button
                onClick={handleOpenModal}
                className="group bg-gradient-to-br from-[#4A7C59] to-[#3a6347] rounded-2xl sm:rounded-3xl p-8 sm:p-10 text-white hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <i className="ri-message-3-line text-3xl sm:text-4xl"></i>
                </div>
                <h4 className="text-2xl font-bold mb-3 text-center">문자 상담</h4>
                <p className="text-white/90 text-center text-base mb-4">메시지 전송</p>
                <p className="text-center font-bold text-xl sm:text-2xl">문자 보내기</p>
              </button>
            </div>

            {/* 추가 정보 */}
            <div className="mt-12 pt-10 border-t border-gray-200">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#FF8E53]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-time-line text-3xl text-[#FF8E53]"></i>
                  </div>
                  <p className="text-gray-600 text-base mb-2">빠른 응답</p>
                  <p className="text-[#2C2C2C] font-bold text-lg">평균 5분 이내</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#0E7FC0]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-user-heart-line text-3xl text-[#0E7FC0]"></i>
                  </div>
                  <p className="text-gray-600 text-base mb-2">로컬 전문가</p>
                  <p className="text-[#2C2C2C] font-bold text-lg">1:1 맞춤 상담</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-[#4A7C59]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-3xl text-[#4A7C59]"></i>
                  </div>
                  <p className="text-gray-600 text-base mb-2">안심 예약</p>
                  <p className="text-[#2C2C2C] font-bold text-lg">투명한 가격</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 문자 메시지 모달 */}
      {showSmsModal && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-3xl w-full max-w-lg overflow-hidden shadow-2xl"
          >
            {/* 헤더 */}
            <div className="bg-gradient-to-r from-[#4A7C59] to-[#3a6347] p-6 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-message-3-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">문자 메시지 보내기</h3>
                    <p className="text-white/90 text-lg mt-1">010-5685-7818</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowSmsModal(false)}
                  className="text-white hover:bg-white/20 p-2 rounded-full transition-all"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            {/* 본문 */}
            <div className="p-6">
              <label className="block text-gray-700 font-semibold mb-3 text-lg">
                메시지 내용
              </label>
              <textarea
                value={smsMessage}
                onChange={(e) => setSmsMessage(e.target.value)}
                placeholder="이름, 지역, 연락처, 문의내용을 입력해주세요..."
                className="w-full border-2 border-gray-300 rounded-xl p-4 resize-none text-gray-700 focus:ring-2 focus:ring-[#4A7C59] focus:border-transparent outline-none text-lg leading-relaxed font-medium"
                style={{
                  fontFamily: 'inherit'
                }}
                rows={10}
                maxLength={500}
              />
              <div className="flex justify-between items-center mt-2">
                <p className="text-base text-gray-500">
                  {smsMessage.length} / 500자
                </p>
              </div>

              {/* 안내 문구 */}
              <div className="mt-4 p-4 bg-gradient-to-r from-[#4A7C59]/10 to-[#3a6347]/10 rounded-xl border-2 border-[#4A7C59]/20">
                <div className="flex items-start gap-2 mb-3">
                  <i className="ri-information-line text-[#4A7C59] text-xl mt-0.5"></i>
                  <div className="flex-1">
                    <p className="text-base text-gray-700 leading-relaxed mb-2">
                      <strong className="text-[#4A7C59]">안녕하세요! 제주블리 여행사에 문의 드립니다.</strong> 문구 아래에 <strong className="text-[#4A7C59]">이름, 지역, 연락처, 내용</strong>을 입력해주세요.
                    </p>
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-2">
                      <p className="text-sm text-amber-800 font-semibold">
                        📱 중요: 문자 앱이 열리면 반드시 전송 버튼을 눌러주세요!
                      </p>
                      <p className="text-xs text-amber-700 mt-1">
                        웹사이트에서는 자동 전송이 불가능합니다. 문자 앱에서 직접 전송해야 메시지가 발송됩니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 버튼 */}
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setShowSmsModal(false)}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 py-4 rounded-xl font-semibold transition-all whitespace-nowrap text-lg"
                >
                  취소
                </button>
                <button
                  onClick={handleSendSms}
                  disabled={isSending || !smsMessage.trim()}
                  className="flex-1 bg-gradient-to-r from-[#4A7C59] to-[#3a6347] hover:from-[#3a6347] hover:to-[#2d4d35] text-white py-4 rounded-xl font-semibold transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap text-lg"
                >
                  {isSending ? (
                    <>
                      <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full"></div>
                      문자 앱 여는 중...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill"></i>
                      문자 앱 열기
                    </>
                  )}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
}
